import {ErrorHandler, Injectable} from "@angular/core";
import {ErrorService} from "./error.service";
import {DataClientError} from "./data-client-error";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

    constructor(private errorService: ErrorService) {
    }

    async handleError(error: any): Promise<void> {
        if (error.rejection instanceof DataClientError) {
            const dataClientError: DataClientError = error.rejection;
            if (!await dataClientError.validationMessages) {
                this.errorService.reportDataClientError(dataClientError);
            }
        } else {
            console.log(error);
            this.errorService.reportError(error);
        }
    }
}
